import React from 'react';
import { FormattedMessage } from 'react-intl';

import Aux from '../../hoc/auxi';

const modalconfig = (props) => {
    let id= '';
    id="exampleModalCenter"+props.modalId;
    let target='';
    target="#exampleModalCenter"+props.modalId;
    return (
        <Aux>
            <i className="fa fa-edit col col-sm-2" style={{color:"#00a099"}} data-toggle="modal" data-target={target}/>

            <div className="modal fade" id={id} tabIndex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLongTitle">Editar campo</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <input type="text" className="form-control" onChange={props.onChange} placeholder={props.modalText}/>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn" data-dismiss="modal"><FormattedMessage id="cancel" /></button>
                            <button type="button" className={props.class} onClick={props.confirm} data-dismiss="modal">{props.action}</button>
                        </div>
                    </div>
                </div>
            </div>
        </Aux>
    )
}

export default modalconfig;


// WEBPACK FOOTER //
// ./src/components/UI/ModalConfig.js